import { render } from "./B2bPageReportesRecibidos.vue?vue&type=template&id=43fca4eb&scoped=true&lang=pug"
import script from "./B2bPageReportesRecibidos.vue?vue&type=script&lang=js"
export * from "./B2bPageReportesRecibidos.vue?vue&type=script&lang=js"

import "./B2bPageReportesRecibidos.vue?vue&type=style&index=0&id=43fca4eb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43fca4eb"]])

export default __exports__